export var SET_INITIAL_STATE = 'SET_INITIAL_STATE';
export var USER_CHOSE_RECOVER_TYPE = 'USER_CHOSE_RECOVER_TYPE';
export var USER_CHOOSE_PHONE_RECOVER = 'USER_CHOOSE_PHONE_RECOVER';
export var USER_CHOOSE_EMAIL_RECOVER = 'USER_CHOOSE_EMAIL_RECOVER';
export var USER_RESET_RECOVER = 'USER_RESET_RECOVER';
export var CHECK_RECOVERY_CODE_VALIDITY_FETCH = 'CHECK_RECOVERY_CODE_VALIDITY_FETCH';
export var CHECK_RECOVERY_CODE_VALIDITY_SUCCESS = 'CHECK_RECOVERY_CODE_VALIDITY_SUCCESS';
export var CHECK_RECOVERY_CODE_VALIDITY_EXPIRED_OR_INVALID = 'CHECK_RECOVERY_CODE_VALIDITY_EXPIRED_OR_INVALID';
export var CHECK_RECOVERY_CODE_VALIDITY_ERROR = 'CHECK_RECOVERY_CODE_VALIDITY_ERROR';
export var SET_CAPTCHA_TOKEN = 'SET_CAPTCHA_TOKEN';
export var RECOVER_BY_EMAIL_FETCH = 'RECOVER_BY_EMAIL_FETCH';
export var RECOVER_BY_EMAIL_SUCCESS = 'RECOVER_BY_EMAIL_SUCCESS';
export var RECOVER_BY_EMAIL_ERROR = 'RECOVER_BY_EMAIL_ERROR';
export var RECOVER_BY_EMAIL_INVALID = 'RECOVER_BY_EMAIL_INVALID';
export var RECOVER_BY_PHONE_FETCH = 'RECOVER_BY_PHONE_FETCH';
export var RECOVER_BY_PHONE_SUCCESS = 'RECOVER_BY_PHONE_SUCCESS';
export var RECOVER_BY_PHONE_ERROR = 'RECOVER_BY_PHONE_ERROR';
export var RECOVER_BY_PHONE_INVALID = 'RECOVER_BY_PHONE_INVALID';
export var SAVE_PASSWORD_FETCH = 'SAVE_PASSWORD_FETCH';
export var SAVE_PASSWORD_SUCCESS = 'SAVE_PASSWORD_SUCCESS';
export var SAVE_PASSWORD_ERROR = 'SAVE_PASSWORD_ERROR';
export var USER_LOCKDOWN = 'USER_LOCKDOWN';